import { render, staticRenderFns } from "./WebSiteSecondary.vue?vue&type=template&id=0777caa3&"
import script from "./WebSiteSecondary.vue?vue&type=script&lang=ts&"
export * from "./WebSiteSecondary.vue?vue&type=script&lang=ts&"
import style0 from "./WebSiteSecondary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports